import { api } from "@/services/api";

export async function calculateShipmentValue(storeId: string, clientId: string) {
  const { data } = await api.post<{ frete: number }>(`/v2/calcular-frete`, {
    id_cliente: clientId,
    id_estabelecimento: storeId,
  });
  return {
    shipmentValue: data?.frete ?? null,
  };
}
